/**
 * Product Card Video Hover/Touch Effect – Inline Style Optimized
 * --------------------------------------------------------------
 * Desktop: plays video on hover, resets and shows fallback on mouse leave.
 * Mobile: plays video fully on first tap; prevents navigation until video ends.
 * Inline styles used for visibility to minimize DOM writes.
 * Preloads all videos on mobile for reliable loading.
 * On history navigation (back/forward), resets all videos, shows fallback, and re-preloads videos.
 */

document.addEventListener('DOMContentLoaded', () => {
  const isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  const productCards = document.querySelectorAll('.product-card');

  // Preload videos as they approach viewport (desktop only)
  const preloadObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target.querySelector('.featured-video');
          if (video) forcePreload(video);
          preloadObserver.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '300px' },
  );

  productCards.forEach((card) => {
    const video = card.querySelector('.featured-video');
    const fallbackImg = card.querySelector('.video-fallback');
    const gallery = card.querySelector('.card-gallery, .product-media');
    if (!video) return;

    // Helper functions to toggle video/fallback efficiently
    const showVideo = () => {
      video.style.display = 'block';
      if (fallbackImg) fallbackImg.style.display = 'none';
    };
    const showFallback = () => {
      video.style.display = 'none';
      if (fallbackImg) fallbackImg.style.display = 'block';
    };

    // Hide all other videos and show their fallback images
    function hideOtherVideos(exceptVideo) {
      document.querySelectorAll('.featured-video').forEach((v) => {
        if (v !== exceptVideo) {
          v.pause();
          v.currentTime = 0;
          v.style.display = 'none';
        }
      });
      document.querySelectorAll('.video-fallback').forEach((img) => (img.style.display = 'block'));
    }

    if (!isMobile) {
      // DESKTOP: hover interactions
      preloadObserver.observe(card);

      card.addEventListener('mouseenter', () => {
        hideOtherVideos(video);
        showVideo();
        safePlay(video, fallbackImg);
      });

      card.addEventListener('mouseleave', () => {
        video.currentTime = 0;
        video.pause();
        showFallback();
      });
    } else {
      // MOBILE: tap to play fully, prevent navigation until done
      let videoPlaying = false;
      const tapTarget = gallery || card;

      function playVideoOnce() {
        hideOtherVideos(video);
        showVideo();
        video.currentTime = 0;
        video.muted = true;
        video.playsInline = true;

        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            showFallback();
            videoPlaying = false;
          });
        }
      }

      function preventNavigation(e) {
        if (e.target instanceof Element && e.target.closest('.product-card-quick-add')) return;
        if (!videoPlaying) {
          e.preventDefault();
          e.stopPropagation();
          videoPlaying = true;
          playVideoOnce();
        }
      }

      tapTarget.addEventListener('touchstart', preventNavigation, { passive: false });
      tapTarget.addEventListener('click', preventNavigation, true);

      video.addEventListener('ended', () => {
        video.currentTime = 0;
        video.pause();
        showFallback();
        videoPlaying = false;
      });

      // Preload all videos on mobile for reliable touch-play
      forcePreload(video);
    }
  });

  // Mobile: preload all videos at page load for reliable touch-play
  if (isMobile) {
    document.querySelectorAll('.featured-video').forEach(forcePreload);
  }

  // On page navigation (back/forward), reset all videos, show fallback, and re-preload videos
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.featured-video').forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.style.display = 'none';
      forcePreload(video); // <--- critical fix for your issue!
    });
    document.querySelectorAll('.video-fallback').forEach((fallbackImg) => {
      fallbackImg.style.display = 'block';
    });
  });

  /**
   * Forces video to preload and caches first frame for smooth playback.
   */
  function forcePreload(video) {
    try {
      video.preload = 'auto';
      video.muted = true;
      video.playsInline = true;
      video.load();

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            video.pause();
            video.currentTime = 0;
          })
          .catch(() => {
            /* autoplay blocked, ignore */
          });
      }
    } catch (err) {
      console.warn('Video preload error:', err);
    }
  }

  /**
   * Attempts to play video; shows fallback image if playback fails.
   */
  function safePlay(video, fallbackImg) {
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        if (fallbackImg) {
          video.style.display = 'none';
          fallbackImg.style.display = 'block';
        }
      });
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var SwiperTop = new Swiper('.marquee--text', {
    spaceBetween: 36,
    centeredSlides: true,
    speed: 10000,
    autoplay: {
      delay: 0,
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    disableOnInteraction: true,
  });
});

//MENU DRAWER MOBILE CLICK JS START

document.querySelectorAll('.custom-menu-drawer .custom-menu-menu-item').forEach(function (el) {
  el.addEventListener('click', function () {
    const drawer = document.querySelector('.header__columns .menu-drawer-container');

    if (drawer) {
      drawer.classList.remove('menu-open');
      drawer.removeAttribute('open');
    }
  });
});

//MENU DRAWER MOBILE CLICK JS END

// ANNOUNCEMENT BAR HEIGHT GET JS START
(function () {
  const init = () => {
    const bar = document.querySelector('.custom-announcement-bar-section [data-bar-id]');
    if (!bar) return;

    const setBarHeight = () => {
      document.body.style.setProperty('--custom-announcement-bar-height', bar.offsetHeight + 'px');
    };

    setBarHeight();
    window.addEventListener('resize', setBarHeight);
    new ResizeObserver(setBarHeight).observe(bar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
// ANNOUNCEMENT BAR HEIGHT GET JS END

//PRODUCT CARD QUICK ADD BUBBLE JS START

(function () {
  const LOADING_MS = 5000;
  let openMenu = null;

  function startLoading(bubble) {
    if (!bubble) return;
    clearTimeout(bubble.quickAddTimer);
    bubble.classList.add('is-loading');
    bubble.quickAddTimer = setTimeout(() => bubble.classList.remove('is-loading'), LOADING_MS);
  }

  function addToCart(form, variantId, quantity) {
    const idInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (!idInput || !variantId) return;

    idInput.value = variantId;
    if (quantityInput && quantity) quantityInput.value = quantity;

    startLoading(form.closest('.product-card-quick-add'));
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function menuItems(menu) {
    return Array.from(menu.querySelectorAll('.product-card-quick-add__option'));
  }

  function toggleFor(menu) {
    return document.querySelector('[aria-controls="' + menu.id + '"]');
  }

  function closeMenu(returnFocus) {
    if (!openMenu) return;
    const menu = openMenu;
    const toggle = toggleFor(menu);
    openMenu = null;
    menu.hidden = true;
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }
  }

  function showMenu(toggle, focusIndex) {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!menu) return;
    closeMenu(false);
    menu.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    openMenu = menu;

    const items = menuItems(menu);
    if (items.length) items[(focusIndex + items.length) % items.length].focus();
  }

  // Fired on success and on error.
  document.addEventListener('cart:update', () => {
    document.querySelectorAll('.product-card-quick-add.is-loading').forEach((bubble) => {
      clearTimeout(bubble.quickAddTimer);
      bubble.classList.remove('is-loading');
    });
  });

  // Touch devices: native picker.
  document.addEventListener('change', (event) => {
    const select = event.target instanceof Element ? event.target.closest('.product-card-quick-add__select') : null;
    if (!select || !select.value || !select.form) return;

    const option = select.options[select.selectedIndex];
    const variantId = select.value;
    // Reset so picking the same option again still fires change.
    select.selectedIndex = 0;
    addToCart(select.form, variantId, option && option.dataset.quantity);
  });

  // product-card.js opens the product for clicks that are not on a button, so the menu's padding and title must not reach it.
  // mousedown too, so clicking them doesn't take focus out of the menu.
  ['mousedown', 'click'].forEach((type) => {
    document.addEventListener(
      type,
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (target && target.closest('.product-card-quick-add__menu') && !target.closest('button')) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true,
    );
  });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const toggle = target.closest('.product-card-quick-add__toggle');
    if (toggle) {
      if (toggle.getAttribute('aria-expanded') === 'true') closeMenu(true);
      else showMenu(toggle, 0);
      return;
    }

    const option = target.closest('.product-card-quick-add__option');
    if (option) {
      const form = option.closest('form');
      closeMenu(true);
      if (form) addToCart(form, option.dataset.variantId, option.dataset.quantity);
      return;
    }

    if (target.closest('.product-card-quick-add__add')) {
      startLoading(target.closest('.product-card-quick-add'));
      return;
    }

    if (openMenu && !openMenu.closest('.product-card-quick-add').contains(target)) closeMenu(false);
  });

  document.addEventListener('keydown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const toggle = target.closest('.product-card-quick-add__toggle');
    if (toggle && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      event.preventDefault();
      showMenu(toggle, event.key === 'ArrowDown' ? 0 : -1);
      return;
    }

    if (!openMenu) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu(true);
      return;
    }
    if (!openMenu.contains(target)) return;
    if (event.key === 'Tab') {
      closeMenu(false);
      return;
    }

    const items = menuItems(openMenu);
    const index = items.indexOf(target);
    let next = null;
    if (event.key === 'ArrowDown') next = items[(index + 1) % items.length];
    else if (event.key === 'ArrowUp') next = items[(index - 1 + items.length) % items.length];
    else if (event.key === 'Home') next = items[0];
    else if (event.key === 'End') next = items[items.length - 1];
    if (next) {
      event.preventDefault();
      next.focus();
    }
  });
})();

//PRODUCT CARD QUICK ADD BUBBLE JS END
